import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { TOSButton } from './style';
import { ColorsV2 } from 'app/constants/color';

const AddToTOSMenu = ({ nrOfQuestionsInBatch, handleOpenTOS, handleOpenConfirmClear }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'gap_analysis' });
  return (
    <>
      <Stack
        direction='row'
        sx={{
          alignItems: 'center',
          bgcolor: ColorsV2.primary,
          maxHeight: '80px',
          borderRadius: '10px',
          paddingTop: '10px',
          paddingBottom: '10px',
          paddingLeft: '20px',
        }}
      >
        <TOSButton
          variant='text'
          disabled={nrOfQuestionsInBatch > 0 ? false : true}
          size='large'
          onClick={handleOpenConfirmClear}
          sx={{
            hidden: nrOfQuestionsInBatch > 0 ? 'false' : 'true',
            maxWidth: { lg: '180px', xl: '280px' },
            boxShadow: 1,

            marginLeft: '20px',
            paddingRight: '10px',
            paddingLeft: '10px',
            alignSelf: 'flex-end',
            backgroundColor: ColorsV2.primary,
            border: '2px solid ' + ColorsV2.outline,
            color: ColorsV2.white,

            '&:hover': {
              backgroundColor: ColorsV2.primary,
              border: '2px solid ' + ColorsV2.acent,
              color: ColorsV2.acent,
            },
          }}
        >
          <Typography variant='subtitle2'>{t('tos_clear_selected')}</Typography>
        </TOSButton>
        <Stack
          direction='row'
          alignItems='center'
          sx={{
            marginLeft: '40px',
            marginRight: '40px',
            maxWidth: '260px',
          }}
        >
          <TOSButton
            variant='text'
            style={{ justifySelf: 'right' }}
            disabled={nrOfQuestionsInBatch > 0 ? false : true}
            size='large'
            onClick={handleOpenTOS}
            sx={{
              hidden: nrOfQuestionsInBatch > 0 ? 'false' : 'true',

              minWidth: { sm: '100px', lg: '180px' },
              maxWidth: { lg: '180px', xl: '280px' },
              alignSelf: 'flex-end',
              backgroundColor: ColorsV2.acent,
              border: '2px solid ' + ColorsV2.acent,
              color: ColorsV2.white,
              boxShadow: 1,

              '&:hover': {
                backgroundColor: ColorsV2.primary,
                color: ColorsV2.acent,
              },
            }}
          >
            <Typography variant='subtitle2'>
              {t('tos_generate_url')} ({nrOfQuestionsInBatch})
            </Typography>
          </TOSButton>
        </Stack>
        <Stack
          sx={{
            paddingRight: '20px',
          }}
        >
          {/* <Typography variant='body2' sx={{
                textAlign: 'center',
            }}>
                {t('tos_service_description')}
            </Typography> */}
        </Stack>
      </Stack>
    </>
  );
};

export default AddToTOSMenu;
